import axios from 'axios';
import { authService } from './authService';

const API_URL = process.env.VUE_APP_AI_URL;

//axios.defaults.baseURL = API_URL;

function onError(err) {
    if (err.response) {
        console.error('onError()->Error response:', err.response.data);
        return {
            Success: false,
            Error: err.response.data.Error,
            Message: 'Error response: ' + err.response.data.Message
        }
    } else if (err.request) {
        console.error('onError()->No response received:', err.response.data);
        return {
            Success: false,
            Error: err.request,
            Message: 'No response received: ' + err.request
        }
    } else {
        console.error('onError()->Error setting up request:', err.response.data);
        return {
            Success: false,
            Error: err.message,
            Message: 'Error setting up request: ' + err.message
        }
    }
}

export const aiService = {
    async sendMessage(aiRequest) {
        try {
            const result = await axios.post(API_URL + "ai/sendMessage", aiRequest);
            return result.data;
        } catch (err) {
            return onError(err);
        }

    },
    async listLocalModels() {
        try {
            const result = await axios.post(API_URL + "ai/listLocalModels");
            return result.data;
        } catch (err) {
            return onError(err);
        }

    }
}

let controller = null;

export const aiServiceFetch = {
    cancel() {
        if (controller) {
            controller.abort();
            controller = null;
        }
    },
    async sendMessageFetch(aiRequest, chatCallback) {
        try {
            controller = new AbortController();
            const response = await fetch(API_URL + "ai/sendMessageFetch", {
                method: "POST",
                headers: { "Content-Type": "application/json", "Authorization": `Bearer ${authService.getAuthToken()}` },
                body: JSON.stringify(aiRequest),
                signal: controller.signal
            });

            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");

            for (; ;) {
                const { value, done } = await reader.read();
                if (done) break;

                chatCallback(decoder.decode(value));
            }
        } catch (err) {
            console.error(err);
        }
    },
    async customQueryFetch(aiRequest, chatCallback) {
        try {
            controller = new AbortController();
            const response = await fetch(API_URL + "ai/customQuery", {
                method: "POST",
                headers: { "Content-Type": "application/json", "Authorization": `Bearer ${authService.getAuthToken()}` },
                body: JSON.stringify(aiRequest),
                signal: controller.signal
            });

            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");

            for (; ;) {
                const { value, done } = await reader.read();
                if (done) break;

                chatCallback(decoder.decode(value));
            }
        } catch (err) {
            console.error(err);
        }
    },
    async embedingItemsFetch(aiRequest, chatCallback) {
        try {
            controller = new AbortController();
            const response = await fetch(API_URL + "ai/embedingItemsFetch", {
                method: "POST",
                headers: { "Content-Type": "application/json", "Authorization": `Bearer ${authService.getAuthToken()}` },
                body: JSON.stringify(aiRequest),
                signal: controller.signal
            });

            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");

            for (; ;) {
                const { value, done } = await reader.read();
                if (done) break;

                chatCallback(decoder.decode(value));
            }
        } catch (err) {
            console.error(err);
        }
    },
    async multiAgentFetch(aiRequest, chatCallback) {
        try {
            controller = new AbortController();
            const response = await fetch(API_URL + "ai/multiAgentFetch", {
                method: "POST",
                headers: { "Content-Type": "application/json", "Authorization": `Bearer ${authService.getAuthToken()}` },
                body: JSON.stringify(aiRequest),
                signal: controller.signal
            });

            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");

            for (; ;) {
                const { value, done } = await reader.read();
                if (done) break;

                chatCallback(decoder.decode(value));
            }
        } catch (err) {
            console.error(err);
        }
    },
};

